import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ModelLoaderService } from '@adex/shared/services/model-loader.service'
import { BaseLoaderContainer } from '@adex/shared/models/loaders/base-loader-container'
import { resetPassword } from '@adex/store/actions/auth.actions'
import { Store } from '@ngrx/store'
import { IEmailDto } from '@adex/shared/models/dto/email.dto'
import { IDynamicFormModel } from '@adex/shared/modules/dynamic-form/models/dynamic-form.model'
import { DynamicFormStateService } from '@adex/shared/modules/dynamic-form'


@Component({
  selector: 'adex-forgot-password-container',
  templateUrl: './forgot-password-container.component.html',
  styleUrls: [ './forgot-password-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ DynamicFormStateService ]
})
export class ForgotPasswordContainerComponent extends BaseLoaderContainer<IDynamicFormModel> {

  constructor(modelLoader: ModelLoaderService, private readonly store: Store) {
    super(modelLoader, 'forgot-form')
  }

  public onSubmitForm(formValue: IEmailDto): void {
    this.store.dispatch(resetPassword({ emailDto: formValue }))
  }

}
